// extracted by mini-css-extract-plugin
module.exports = {"icon":"AssetPreview_icon__1dKam"};